import { render } from "./suggestion-pop.vue?vue&type=template&id=314d7d88"
import script from "./suggestion-pop.vue?vue&type=script&lang=js"
export * from "./suggestion-pop.vue?vue&type=script&lang=js"

import "./suggestion-pop.vue?vue&type=style&index=0&id=314d7d88&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-search-bar/_component/suggestion/suggestion-pop.vue'],['render',render],['__file',"suggestion-pop.vue"]])

export default __exports__